import {InfoEntry, TFaqSection, TMetaData} from '.'

const MetaData: TMetaData = {
  title: 'ऑनलाइन गेम्स फ्री में खेलें बिना डाउनलोड किए | Gamezop',
  desc: 'ऑनलाइन गेम्स फ्री में खेलें बिना डाउनलोड किए!, जिसमें 200+ ऐक्शन, एडवेंचर, पज़ल, रेसिंग जैसे सबसे अच्छे और शानदार गेम्स शामिल हैं। अभी खेलें ये फ्री गेम्स!',
}

const InfoData: InfoEntry[] = [
  {
    tag: 'h1',
    title: 'ऑनलाइन गेम्स फ्री में खेलें बिना डाउनलोड किए',
    body: {
      text: [
        `Gamezop पर खेलें मजेदार और फ्री ऑनलाइन गेम्स, बिना किसी डाउनलोड के झंझट के!
        बस अपनी पसंद का गेम चुनें और कुछ ही सेकंड में खेलना शुरू करें। हमारे पास 200 से भी ज़्यादा फ्री गेम्स हैं, जो एक्शन, एडवेंचर, आर्केड, पज़ल, रेसिंग और कई अन्य कैटेगरी में आते हैं। चाहे आप मोबाइल, पीसी या आईओएस पर खेलना चाहते हों, यहां हर किसी के लिए बेहतरीन फ्री गेम्स मौजूद हैं।`,
        `अगर आप बोर हो रहे हैं, तो Gamezop पर आपको बोरियत भगाने के लिए ढेरों मजेदार ऑप्शन मिलेंगे। कभी दुश्मनों को रोकने के लिए डिफेंस बनाएँ, कभी निशाना लगाकर शूट करें, या फिर रुकावटों को पार करें। हमारे पास कई रोमांचक गेम्स हैं, जैसे Kingdom Fight, City Cricket, Fruity Fiesta और भी बहुत कुछ! Gamezop पर हर उम्र के लिए मजेदार और एंगेजिंग गेम्स उपलब्ध हैं—बच्चों, बड़ों और बुजुर्गों के लिए भी।`,
        `यहां खेलने के लिए आपको महंगे डिवाइस की कोई जरूरत नहीं है। हमारे गेम्स बिना इंस्टॉल और डाउनलोड के चलते हैं—बस एक ब्राउज़र और इंटरनेट कनेक्शन चाहिए। ये गेम्स डेस्कटॉप, लैपटॉप, क्रोमबुक, स्मार्टफोन, टैबलेट और बाकी सभी डिवाइसेज़ पर आसानी से चलते हैं।`,
      ],
      list: [],
    },
    links: {
      'Kingdom Fight': {
        type: 'game',
        name: 'Kingdom Fight',
        code: 'SyfxJ3a75Cr',
      },
      'City Cricket': {
        type: 'game',
        name: 'City Cricket',
        code: 'HJP4afkvqJQ',
      },
      'Fruity Fiesta': {
        type: 'game',
        name: 'Fruity Fiesta',
        code: 'mKZZW9NXW',
      },
    },
  },
  {
    tag: 'h2',
    title: 'सबसे अच्छे फ्री ऑनलाइन गेम्स कौनसे हैं ?',
    body: {
      text: [],
      list: [
        {
          name: 'Bubble Wipeout',
          code: 'H1AN6fkwqJ7',
          type: 'game',
        },
        {
          name: 'Mahjong At Home: Scandinavian Edition',
          code: 'JVhRZNwly',
          type: 'game',
        },
        {
          name: 'Merge Mania',
          code: 'hfPOimYqY',
          type: 'game',
        },
        {
          name: 'Chef Tycoon',
          code: 'xqO4nZ6Kt',
          type: 'game',
        },
        {
          name: 'Cyberfusion',
          code: 'HJXei0j',
          type: 'game',
        },
        {
          name: 'Mafia Billiard Tricks',
          code: 'SkkV6MJD51Q',
          type: 'game',
        },
        {
          name: 'Spider Solitaire',
          code: 'B1MfIa4QCg',
          type: 'game',
        },
        {
          name: 'Basket Champs',
          code: 'S1_V6GyP5ym',
          type: 'game',
        },
        {
          name: 'Algerian Solitaire',
          code: 'rJu76zkD917',
          type: 'game',
        },
        {
          name: 'Dragon Annihilation',
          code: 'PdIZyZNAe',
          type: 'game',
        },
      ],
    },
    initalState: 'initial_open',
  },
  {
    tag: 'h2',
    title: 'दोस्तों के साथ खेलने के लिए फ्री ऑनलाइन गेम्स कौनसे हैं ?',
    body: {
      text: [],
      list: [
        {
          name: 'Ludo with Friends',
          code: 'SkhljT2fdgb',
          type: 'game',
        },
        {
          name: 'ZUNO',
          code: 'ByQxJnp7qRB',
          type: 'game',
        },
        {
          name: 'Tic Tac Toe',
          code: 'H1WmafkP9JQ',
          type: 'game',
        },
        {
          name: 'Ludo Dash',
          code: 'SJRX12TXcRH',
          type: 'game',
        },
      ],
    },
    initalState: 'initial_open',
  },
  {
    tag: 'h2',
    title: 'सबसे पॉपुलर ऑनलाइन गेम्स के प्रकार कौन-कौन से हैं ?',
    body: {
      text: [],
      list: [
        {
          name: 'क्रेज़ी गेम्स',
          nameEn: 'Crazy games',
          code: '10',
          type: 'tag',
        },
        {
          name: 'बोर्ड गेम्स',
          nameEn: 'Board games',
          code: '11',
          type: 'tag',
        },
        {
          name: 'एडवेंचर गेम्स',
          nameEn: 'Adventure games',
          code: '14',
          type: 'tag',
        },
        {
          name: 'पज़ल गेम्स',
          nameEn: 'Puzzle games',
          code: '8',
          type: 'tag',
        },
        {
          name: 'शूटिंग गेम्स',
          nameEn: 'Shooting games',
          code: '2',
          type: 'tag',
        },
      ],
    },
    initalState: 'initial_open',
  },
  {
    tag: 'h2',
    title: 'Gamezop क्या हैं ?',
    body: {
      text: [
        `Gamezop एक प्लग-एंड-प्ले गेमिंग प्लेटफॉर्म है, जो ऐप्स और वेबसाइट्स को कैज़ुअल गेम्स को आसानी से इंटिग्रेट करने की सुविधा देता है, जिससे यूजर एंगेजमेंट में सुधार होता है। गेमिंग से आगे बढ़कर, Gamezop कई स्पेशलाइज्ड प्लेटफॉर्म्स को भी ऑपरेट करता है: Quizzop इंटरएक्टिव क्विज़ और ट्रिविया के लिए, Astrozop ज्योतिषीय जानकारी और भविष्यवाणियों के लिए, Criczop लाइव क्रिकेट स्कोर और अपडेट्स के लिए, और Feedzop क्यूरेटेड न्यूज़ एग्रीगेशन के लिए। ये सभी प्लेटफॉर्म्स मिलकर एक व्यापक कंटेंट सॉल्यूशन प्रदान करते हैं, जो अलग-अलग ऑडियंस की रुचियों को पूरा करते हैं।`,
        `70 से अधिक देशों में 8,000 से ज्यादा इंटिग्रेशन के साथ, Gamezop और इसके प्लेटफॉर्म्स पर Amazon, Samsung Internet, Snap, Tata Play, AccuWeather और Paytm जैसे ग्लोबल ब्रांड्स भरोसा करते हैं। ये सॉल्यूशन्स न केवल यूजर एंगेजमेंट को बढ़ाते हैं, बल्कि नए रेवेन्यू अवसर भी खोलते हैं। इंटिग्रेशन बेहद सरल है, जिसमें सिर्फ 30 मिनट लगते हैं, और ऐप्स और वेबसाइट्स को गेम्स, क्विज़, ज्योतिष, क्रिकेट और न्यूज़ जैसे कंटेंट से सशक्त बनाते हैं।`,
      ],
      list: [],
    },
    initalState: 'initial_open',
  },
]

const FaqData: TFaqSection = {
  headTag: 'h2',
  headTitle: 'ऑनलाइन गेम्स के बारे में अक्सर पूछे जाने वाले सवाल',
  faqs: [
    {
      tag: 'h3',
      title: 'क्या मैं बिना डाउनलोड और इंस्टॉल किए फ्री गेम्स खेल सकता हूँ ?',
      body: ['हाँ, आप बिना डाउनलोड या इंस्टॉल किए फ्री गेम्स खेल सकते हैं।'],
    },
    {
      tag: 'h3',
      title: 'क्या मुझे गेम खेलने के लिए साइन अप करना पड़ेगा ?',
      body: [
        'नहीं, आपको Gamezop.com पर गेम्स खेलने के लिए साइन अप करने की जरूरत नहीं है। आप बिना किसी रजिस्ट्रेशन के तुरंत गेम खेलना शुरू कर सकते हैं।',
      ],
      links: {
        'Gamezop.com': 'https://www.gamezop.com/hi',
      },
    },
    {
      tag: 'h3',
      title: 'क्या फ्री ऑनलाइन गेम्स खेलना सेफ हैं ?',
      body: [
        'हाँ, फ्री ऑनलाइन गेम्स खेलना सेफ है जब आप हमारी तरह भरोसेमंद वेबसाइट्स का इस्तेमाल करते हैं जो यूजर की सुरक्षा को प्राथमिकता देती हैं। हमारे गेम्स बिना डाउनलोड के चलते हैं, जिससे मैलवेयर का खतरा कम होता है, और हम आपकी प्राइवेसी या डिवाइस की सेफटी से समझौता किए बिना एक सेफ गेमिंग अनुभव प्रदान करते हैं।',
      ],
    },
    {
      tag: 'h3',
      title: 'क्या फ्री गेम्स वाकई फ्री होते हैं ?',
      body: [
        'हाँ, Gamezop पर फ्री गेम्स खेलने के लिए पूरी तरह मुफ्त हैं। हालांकि, प्लेटफॉर्म को सपोर्ट करने के लिए इन गेम्स में विज्ञापन दिखाए जा सकते हैं।',
      ],
    },
    {
      tag: 'h3',
      title: 'क्या सीनियर्स के लिए फ्री ऑनलाइन गेम्स हैं ?',
      body: [
        'जी हाँ, हमारे पास सीनियर्स के लिए कई मजेदार फ्री ऑनलाइन गेम्स हैं, जैसे Sudoku Classic, Solitaire Gold, Chess Grandmaster और कई अन्य।',
      ],
      links: {
        'Sudoku Classic': {
          type: 'game',
          name: 'Sudoku Classic',
          code: 'SJgx126Qc0H',
        },
        'Solitaire Gold': {
          type: 'game',
          name: 'Solitaire Gold',
          code: 'rkPlk2T7qAr',
        },
        'Chess Grandmaster': {
          type: 'game',
          name: 'Chess Grandmaster',
          code: 'rkAXTzkD5kX',
        },
      },
    },
  ],
}

export default {
  meta: MetaData,
  info: InfoData,
  faq: FaqData,
}
